import React__default__default from 'react';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/data-table.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import { CellContent } from '../../data-table-prop-types.js';
import { Injecss } from '../../../../packages/injecss/injecss.js';

/* eslint-disable react/no-array-index-key */
const dataTableBem = HoneyBem.init('data-table', styles);
const DataTableFooter = _ref => {
  let {
    footers
  } = _ref;
  return /*#__PURE__*/React__default__default.createElement("tfoot", {
    className: dataTableBem.e('footer')
  }, /*#__PURE__*/React__default__default.createElement("tr", null, footers.map((footer, index) => index === 0 ? /*#__PURE__*/React__default__default.createElement("th", {
    scope: "row",
    key: index
  }, footer) : /*#__PURE__*/React__default__default.createElement("td", {
    key: index
  }, footer))));
};
DataTableFooter.displayName = 'DataTableFooter';
DataTableFooter.propTypes = {
  /** List of table footers: [`string`|`node`|`number`] */
  footers: CellContent.isRequired
};
var DataTableFooter$1 = Injecss(DataTableFooter, styles);

export { DataTableFooter$1 as default };
